import type { TState } from 'config/types'

export const selectFlashMessages = (state: TState) => state.app.flashMessages

export const selectPopin = (state: TState) => state.app.popin || {}

export const isLangBarOpen = (state: TState) => !!state.app.isLangBarOpen

export const hasAcceptedCookies = (state: TState) => !!state.app.hasAcceptedCookies

export const isNavigationOpen = (state: TState) => !!state.app.isNavigationOpen

export const selectPrompts = (state: TState) => state.app.prompts

export const isHydrated = (state: TState) => state.app.isHydrated

export const selectTitle = (state: TState) => state.app.title
